__turbopack_context__.v({
  "content": "styles-module__w8glla__content",
  "image": "styles-module__w8glla__image",
  "reverse": "styles-module__w8glla__reverse",
  "segment": "styles-module__w8glla__segment",
  "title": "styles-module__w8glla__title",
});
